import React from 'react';
import './App.css';
import HeroSection from './components/HeroSection';
import MattressGallery from './components/MattressGallery';
import OurMission from './components/OurMission';
import Footer from './components/Footer';
import Header from './components/Header';

function App() {
  return (
    <div className="App">
      <Header />
      <HeroSection />
      <MattressGallery />
      <OurMission />
      <Footer />
    </div>
  );
}

export default App;